<template>
  <Modal middle v-model="opened"  hasCloseIcon hasDivider>
    <div slot="header" v-width="modalWidth"><b>Configurações</b></div>
    <h2>Personalize o comportamento da plataforma F360 Performance.</h2>
    <br />
    <div class="tabs-config">
      <Tabs :datas="paramTab" class-name="h-tabs-card" v-model="selected" @change="() => {}" />
    </div>
    <p class="config-desc">Personalizar o comportamento da Dashboard. Isto afetará o comportamento de todas as dashboards já criadas e que ainda serão criadas.</p>
    <div>
    </div>
    <template>
      <div class="config-pdv" >
        <fieldset>
            <legend> Vale Troca: </legend>
            <span class="h-tag h-tag h-tag-gray info-container">
              <i class="h-icon-info info-config" />
              Configura a Dashboard para apresentar valores baseados no produto da subtração do total de vendas realizadas pelo total de vale troca realizado.
            </span>
            <Checkbox v-model="microvix.considerarTrocaDevolucao">
              <b>
                Subtrair vale-troca:
              </b>
            </Checkbox>
        </fieldset>
        <fieldset>
          <legend> Metas: </legend>
          <span class="h-tag h-tag h-tag-gray info-container">
            <i class="h-icon-info info-config" />
            Os widgets do tipo cards irão exibir um gráfico extra com o valor da meta mensal.
          </span>
          <Checkbox v-model="exibirMetaMensal">
            <b>
              Configura a Dashboard para Exibir meta total do mês :
            </b>
          </Checkbox>
      </fieldset>
      <fieldset>
        <legend>  Valores: </legend>
        <span class="h-tag h-tag h-tag-gray info-container">
          <i class="h-icon-info info-config" />
          Configurar a dashboard para exibir valores de indicadores baseados em:
        </span>
        <Radio :disabled="disabledValueType" v-model="filtrosAvancados" :value="0">
          <b>
            Receita Líquida das vendas
          </b>
        </Radio>
        <Radio :disabled="disabledValueType" v-model="filtrosAvancados" :value="1">
          <b>
            Receita Bruta das vendas
          </b>
        </Radio>
    </fieldset>
    <fieldset>
      <legend> Atualização automática:</legend>
      <span class="h-tag h-tag h-tag-gray info-container">
        <i class="h-icon-info info-config" />
        Atualizar os dados da Dashboard automaticamente garantindo que os dados mais recentes estejam disponíveis em um intervalo de tempo definido.
      </span>
      <Select v-model="tempoAtualizar" :datas="atualizarTempoRealParms" />
  </fieldset>
      </div>
    </template>
    <div slot="footer">
      <button  data-test="salvar" class="h-btn h-btn-green" @click="handleSaveConfig">Salvar</button>
      <button class="h-btn" data-test="fechar"  @click="handleCloseModal">Fechar</button>
    </div>
  </Modal>
</template>

<script>
import { configuracoes } from '@/components/mixins/configuracoes';
import { ScreenSize } from '../../mixins/ModalSize';
const pdvs = [{ key: '1', title: 'PDV Microvix XLS' }];
export default {
  mixins: [ScreenSize, configuracoes],
  props: {
    isOpen: {
      type: Boolean,
      require: true
    }
  },
  data() {
    return {
      opened: false,
      listaPdvs: pdvs,
      microvix: {
        considerarTrocaDevolucao: false
      },
      selected: 'dashboard',
      primeiroAcesso: true,
      isLoading: false,
      configurationId: ''
    };
  },
  computed: {
    modalWidth() {
      return this.screen.widthSize - (this.screen.widthSize / 2);
    },
    paramTab() {
      return {
        dashboard: 'Dashboard'
      };
    },
    comportamento() {
      return {
      };
    },
    configsParams() {
      const idConfigMicrovix = this.microvix.considerarTrocaDevolucao ? 2 : 1;
      const nameConfigMicrovix = this.microvix.considerarTrocaDevolucao ? 'SubtractFromTotalAmount' : 'CreateZeroCoupon';
      const funcType = {
        true: {
          functionality: 'ETLEngineConfiguration',
          configurationType: { 'id': 1, 'name': 'ExchangeVoucherBehaviour' },
          configurationDefinition: { 'id': idConfigMicrovix, 'name': nameConfigMicrovix }
        } }.true;
      const { functionality, configurationType, configurationDefinition } = funcType;
      return [{ functionality, configurationType, configurationDefinition }];
    },
    disabledValueType() {
      return this.microvix.considerarTrocaDevolucao;
    }
  },
  watch: {
    opened(value) {
      if (!value) this.$emit('closeModalConfig');
    },
    async isOpen(value) {
      this.opened = value;
      this.setPreferencias();
      try {
        const { _response } = await R.Configs.listarTodos();
        const { etlEngineConfiguration } = (_response.data.data);
        this.microvix.considerarTrocaDevolucao = etlEngineConfiguration.ExchangeVoucherBehaviour.enumMemberValue === 2;
      } catch (error) {
        this.$Message.error('Houve um erro ao salvar');
        console.log(error);
      }
    },
    'microvix.considerarTrocaDevolucao': function (value) {
      if (value) this.filtrosAvancados = 0;
    }
  },
  methods: {
    handleCloseModal() {
      this.$emit('closeModalConfig');
    },
    async handleSaveConfig() {
      try {
        this.$Loading();
        await R.Configs.atualizar(this.configsParams, this.configurationId);
        this.$Message('Configuração salva com sucesso!');
        this.opened = false; // mudar quando hover mais que uma configuracao
        this.$emit('atualizarTabela');
      } catch (error) {
        this.$Message.error('Houve um erro ao salvar');
        console.log(error);
      } finally {
        this.$root.$emit('atualizarPreferencias', this.preferencias);
        this.$Loading.close();
      }
    },
    setPreferencias() {
      const preferencias = localStorage.getItem('v360.preferencias');
      if (!preferencias) return;
      const {
        filtrosAvancados,
        atualizacaoAtomatica,
        exibirMetaMensal } = JSON.parse(preferencias);
      this.exibirMetaMensal = exibirMetaMensal;
      this.filtrosAvancados = filtrosAvancados;
      this.tempoAtualizar = atualizacaoAtomatica.tempoAtualizar;
    }
  },
  async created() {
    //  microvix
    // ExchangeVoucherBehaviour
    // 1 - "CreateZeroCoupon" considerarTrocaDevolucao = false
    // 2 - SubtractFromTotalAmount considerarTrocaDevolucao = true
    try {
      let { _response } = await R.Configs.listarTodos();
      this.configurationId = _response.data.data
        ? _response.data.data._id
        : _response.data._id;
      const { etlEngineConfiguration } = _response.data.data || _response.data;
      this.microvix.considerarTrocaDevolucao = etlEngineConfiguration.ExchangeVoucherBehaviour.enumMemberValue === 2;
    } catch (error) {
      this.$Message.error('Houve um erro ao salvar');
      console.log(error);
    }
  }
};
</script>

<style lang="less" scoped>
  .tabs-config{
    margin-bottom:  8px;
  }
  .config-pdv{
    max-height: 70vh;
    overflow: scroll;
    fieldset{
      padding: 4px 8px;
      display: flex;
      flex-direction: column;
      gap: 4px;
      margin: 8px 0;
      .h-radio{
        height: 25px;
      }
    }
  }
  .info-config{
    font-size: 18px;
  }
  .info-container{
    margin: 4px 0;
    padding: 0px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 6px;
  }
  .form-item-config{
    margin-top: 4px;
    font-weight: bold;
  }
  .config-desc{
   color: #6a6a6a;
   font-size: 12px;
   font-weight: bold;
   margin: 0 4px;
  }
</style>
